import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import * as code from "../config/Constants";
// import * as types from "./actions";
// import * as message from "../config/CommonMessages";

 


/**
 * get ai model
 * 19-7-2023
 */

export function getAllMasterDataCategories() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllMasterListing, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

export function addMasterCategory(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.addToMasterListing, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          return response;
        }
      }
    );
  };
}

export function updateLookupCategories(data,id) {
     let url = UrlConstants.updateLookUpCategories;
      url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          return response;
        }
      }
    );
  };
}

export function updatecategoruActiveInActiveStatus(data,id) {
    let url = UrlConstants.updatActiveInActiveStatus;
    url = url.replace("{id}", id);
 return function(dispatch) {
   return APIUtil.putMethod(url, data, true).then(
     (response) => {
       if (response.status === code.OK) {
         return response;
       } else {
         return response;
       }
     }
   );
 };
}

export function getAllMasterDataSubCategories() {
    return function(dispatch) {
      return APIUtil.getMethod(UrlConstants.getAllMasterListingSubCat, true).then((response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      });
    };
  }

  export function addMasterSubCategory(data) {
    return function(dispatch) {
      return APIUtil.postMethod(UrlConstants.addToMasterLookSubCat, data, true).then(
        (response) => {
          if (response.status === code.OK) {
            return response;
          } else {
            return response;
          }
        }
      );
    };
  }


  export function updateLookupSubCategories(data,id) {
    let url = UrlConstants.updateMasterData;
     url = url.replace("{id}", id);
 return function(dispatch) {
   return APIUtil.putMethod(url, data, true).then(
     (response) => {
       if (response.status === code.OK) {
         return response;
       } else {
         return response;
       }
     }
   );
 };
}


export function updateLookupdatcategoruActiveInActiveStatus(data,id) {
    let url = UrlConstants.updateMasterDataStatus;
    url = url.replace("{id}", id);
 return function(dispatch) {
   return APIUtil.putMethod(url, data, true).then(
     (response) => {
       if (response.status === code.OK) {
         return response;
       } else {
         return response;
       }
     }
   );
 };
}


export function getMasterDatabyShortCode(id) {
  let url = UrlConstants.getMasterdatabyStatuscode;
   url = url.replace("{id}", id);
return function(dispatch) {
 return APIUtil.getMethod(url,false).then(
   (response) => {
     if (response.status === code.OK) {
       return response;
     } else {
       return response;
     }
   }
 );
};
}


